import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Icon from 'icon-component';

class DialogClose extends Component {
    constructor(props) {
        super(props);

        this._closeClick = this._closeClick.bind(this);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    _closeClick(evt) {
        this.props.onClick();
    }

    render() {
        return (
            <button className="Dialog-close" onClick={this._closeClick}>
                <Icon name="times" />
            </button>
        );
    }
}

DialogClose.propTypes = {
    onClick: PropTypes.func
};

export default DialogClose;



// WEBPACK FOOTER //
// ./frontend/src/js/components/dialog/DialogClose.jsx